import { api } from "@/utils/api"

/**
 * 获取人脸实体ID的异步函数
 * @param {Object} req - 请求参数对象
 * @returns {Promise} 返回API请求的响应结果
 */
const getFaceEntityIdApi = async (req) => {
	// 发送POST请求获取人脸ID
	return await api.post("/api/detection/faceId", req, {
		headers: {
			// 设置请求头为multipart/form-data格式
			"Content-Type": "multipart/form-data",
		},
    customHandler: (response) => {
      return response
		}
	})
}
/**
 * 上传实时心率变异性(HRV)检测数据的API函数
 * @param {Object} req - 包含HRV检测数据的请求对象
 * @returns {Promise} - 返回API请求的Promise结果
 */
const uploadDetectionDataApi = async (req) => {
	// 使用POST方法向服务器发送实时HRV数据
	return await api.post("/api/hrv/upload/realtime", req, {
		customHandler: (response) => {
      return response
		}
	})
}

/**
 * 获取HRV(心率变异性)报告的API函数
 * @param {Object} req - 请求参数对象
 * @returns {Promise} 返回一个Promise对象，包含API的响应数据
 */
const getHrvReportApi = async (req) => {
	// 使用api.get方法发送GET请求获取HRV报告
	// 请求路径为/api/hrv/report/加上传入的req参数
	return await api.get(`/api/hrv/report/${req}`)
}

/**
 * 获取公众号分享签名
 * @param {Object} req - 请求参数对象
 * @returns {Promise} 返回一个Promise对象，包含API的响应数据
 */
const getHrvWechatShareSignatureApi = async (req) => {
	return await api.post("/api/wechat/signature", req, {
		customHandler: (response) => {
      	return response
		}
	})
}

/**
 * 获取HRV初始化数据的异步函数
 * 该函数通过API调用获取HRV相关的初始化信息
 * @returns {Promise} 返回API调用的结果，包含HRV初始化数据
 */
const getHrvInitApi = async () => {
	return await api.get("/api/hrv/init") // 调用API获取HRV初始化数据
}
export { getFaceEntityIdApi, uploadDetectionDataApi,getHrvReportApi,getHrvInitApi, getHrvWechatShareSignatureApi }
